module.exports = __webpack_public_path__ + "static/img/saleicon2.384fcb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saleicon2.png
// module id = xHKc
// module chunks = 2